import ProjectCollectionModel from "../../../core/model2/project-collection/project-collection-model";
import CustomView from "../../../core/model2/custom-view/custom-view";
import {NavigationSectionType} from "../../../core/model2/navigation/@const";
import {MY_WORK_VIEWS} from "../../../core/gd/const/views/view-type-config"


export default function mainMenu_homeViews():CustomView[] | ProjectCollectionModel[] {

    const customViews = _.filter(gd.session.customViews.models, (view:CustomView)=>{
        if (
            (view.location!==NavigationSectionType.HOME && view.location!==NavigationSectionType.TOOLS)
            && view.location!==NavigationSectionType.HOME_MENU
        ) return

        return !MY_WORK_VIEWS.includes(view.type)
    }) as CustomView[];


    const portfolioViews = _.filter(gd.session.projectCollections.modelsNotInStructure, (portfolio)=>{
        return portfolio.location===NavigationSectionType.HOME || portfolio.location===NavigationSectionType.TOOLS
    }) as ProjectCollectionModel[]

    // @ts-ignore
    return [...customViews, ...portfolioViews]

}
